export default __webpack_public_path__ + "static/desk-property01-f758a2f807ce75b7bac9ddd3c83f65f4.png";